import { HsHypersceneEngineConstants } from '../../constants/hyperscene-engine-constants.global';
import { HsMatrix4 } from '../../../math-new/objects/matrix4.class';
import { HsCamera } from './camera.class';
import { HsHypersceneConstants } from '../../../math-new/constants/hyperscene-constants.global';

export class HsPerspectiveCamera extends HsCamera {
  public fov: number = HsHypersceneConstants.PI_DIV_4;
  public aspect: number = HsHypersceneEngineConstants.ASPECT_16_9;

  protected calculateProjectionMatrix(): void {
    this.projectionMatrix = HsMatrix4.makePerspectiveMatrix(this.fov, this.aspect, this.near, this.far);
  }
}
